import { JornadaUsuario } from '../store/practicas/types';

export const getJourneyFromJourneyList = (
  journeys: JornadaUsuario[],
  idJourneyToSearch: string
): JornadaUsuario | undefined => {
  return journeys.find(
    (j: JornadaUsuario | undefined) => j?.ID_JORNADA === idJourneyToSearch
  );
};
export const getNewDateMilliseconds = (date: any, time: any): number => {
  const updateDate = new Date(Number(date));
  if (time.length === 5) {
    const hours = time.slice(0, 2);
    const minutes = time.slice(3, 5);
    const seconds = 0;
    updateDate.setHours(Number(hours), Number(minutes), Number(seconds));
    return Math.floor(updateDate.getTime());
  }

  if (time.length === 4) {
    const hours = time.slice(0, 2);
    const minutes = time.slice(2, 4);
    const seconds = 0;
    updateDate.setHours(Number(hours), Number(minutes), Number(seconds));
    return Math.floor(updateDate.getTime());
  }
  return 0;
};
// By a Date class object returns the date in format dd/mm/yyyy
const dateFormat = (date: Date, showHours: boolean = false) => {
  const day =
    date.getDate().toString().length === 1
      ? '0' + date.getDate().toString()
      : date.getDate().toString();
  const month =
    (date.getMonth() + 1).toString().length === 1
      ? '0' + (date.getMonth() + 1).toString()
      : (date.getMonth() + 1).toString();
  const year = date.getFullYear().toString();

  const hours =
    date.getHours().toString().length === 1
      ? `0${date.getHours().toString()}`
      : date.getHours().toString();

  const minutes =
    date.getMinutes().toString().length === 1
      ? `0${date.getMinutes().toString()}`
      : date.getMinutes().toString();

  const hour = showHours ? `${hours}:${minutes}` : '';

  return `${day}/${month}/${year} ${hour}`.trim();
};
export const parseJourneys = (data: any) => {
  return data.map((item: any) => {
    const init = dateFormat(new Date(item.FECHA_INI_JORNADA), true);
    const final = dateFormat(new Date(item.FECHA_FIN_JORNADA), true);

    const isAnulated = item.ESTADO_JORNADA === 'AN';

    const anuladaText = isAnulated ? ' - Anulada' : '';

    return {
      label: `${init} - ${final}${anuladaText}`,
      value: item,
      active: false,
      isAnulated,
    };
  });
};
export const parseJourney = (journeyData: any) => {
  const init = new Date(journeyData.FECHA_INI_JORNADA);
  const final = new Date(journeyData.FECHA_FIN_JORNADA);
  return dateFormat(init) + ' - ' + dateFormat(final);
};
